import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'

import RateActivityStar from './subcomponents/RateActivityStar'

export const LABELS = [
  t("I didn't understand much of this"),
  t("I struggled with it, but it wasn't impossible"),
  t("I did pretty well and didn't need much help"),
  t('This was quite easy for me'),
]

const NEVER_HOVERED_VALUE = -1

const RateActivity = ({
  labels = LABELS,
  value: initialValue,
  onChange,
  ariaLabelledby,
}) => {
  const [value, setValue] = useState(initialValue || 0)
  const [hoverValue, setHoverValue] = useState(NEVER_HOVERED_VALUE)
  const uniqueName = `rate-activity-${Math.random()}`

  const handleChange = (event) => {
    const newValue = Number(event.currentTarget.value)

    setValue(newValue)
    onChange?.(newValue)
  }

  const handleMouseEnter = (event) => {
    const newHoverValue = Number(event.currentTarget.dataset.value)

    setHoverValue(newHoverValue)
  }

  const handleMouseLeave = () => {
    setHoverValue(0)
  }

  const handleHoverCanceled = () => {
    setHoverValue(NEVER_HOVERED_VALUE)
  }

  return (
    <Box
      as="fieldset"
      aria-labelledby={ariaLabelledby}
      onMouseLeave={handleHoverCanceled}
    >
      <Flex alignItems="center" justifyContent="center">
        {labels.map((label, index) => {
          const id = `id-${uniqueName}-${index}`
          const optionValue = String(index + 1)

          return (
            <Box
              key={index}
              as="label"
              htmlFor={id}
              ml={index > 0 ? '1x' : 0}
              sx={{
                cursor: 'pointer',
              }}
              data-value={optionValue}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Box
                id={id}
                as="input"
                type="radio"
                checked={optionValue === String(value)}
                value={optionValue}
                name={uniqueName}
                variant="a11y.hidden"
                onChange={handleChange}
              />
              <Box as="span" variant="a11y.hidden">
                {label}
              </Box>
              <RateActivityStar
                active={hoverValue > 0 ? index < hoverValue : index < value}
              />
            </Box>
          )
        })}
      </Flex>
      {(hoverValue > NEVER_HOVERED_VALUE || value > 0) && (
        <Box variant="text.paragraph" color="gray60" mt="2x" textAlign="center">
          {hoverValue > 0 ? (
            labels[hoverValue - 1]
          ) : value > 0 ? (
            labels[value - 1]
          ) : (
            <span>&nbsp;</span> // to avoid jumping when hovered several stars
          )}
        </Box>
      )}
    </Box>
  )
}

RateActivity.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.number,
  onChange: PropTypes.func,
  ariaLabelledby: PropTypes.string,
}

export default RateActivity
